import { render } from "./Unternehmen.vue?vue&type=template&id=10c2cbae"
import script from "./Unternehmen.vue?vue&type=script&lang=js"
export * from "./Unternehmen.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Git-Local\\stfg.git\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__